module.exports = __webpack_public_path__ + "static/media/slakteweb-tekst-logo-blaa.bc912ea1.svg";